import httpUtils, { jsonToImmutableError } from '@gonfalon/legacy-http-client/httpUtils';

export function resendUnverifiedMemberEmailVerification(
  email: string,
  customReferer?: string,
): Promise<void | Response> {
  const body = customReferer ? { email, customReferer } : { email };
  return httpUtils.post('/internal/account/resend-verification', { body }).catch(jsonToImmutableError);
}

export function resendChooseOrganizationEmailVerification(email: string): Promise<void | Response> {
  return httpUtils
    .post('/internal/unauthenticated-members/organization-verifications', { body: { email } })
    .catch(jsonToImmutableError);
}

export function completeUnverifiedMemberSignUp(
  token: string,
  accountId?: string,
  referrer = '',
): Promise<void | Response> {
  return httpUtils
    .post(`/internal/account/signup/complete/${token}`, { body: { accountId, customReferer: referrer } })
    .catch(jsonToImmutableError);
}

/**
 * PATCH /unauthenticated-members/organization-verifications/{token}
 * 200 - success
 * 400 - invalid json or request
 * 401 - expired or invalid token
 * 404 - invalid token
 */
export function verifyOrganizationAccessToken(token: string, body: { action: 'verify' | 'expire' }) {
  return httpUtils
    .patch(`/internal/unauthenticated-members/organization-verifications/${token}`, { body })
    .catch((resp) => jsonToImmutableError(resp));
}

export function getTrustedDeviceTokenInfo(token: string) {
  return httpUtils
    .get(`/internal/unauthenticated-members/organization-verifications/${token}`)
    .then((res) => res.json())
    .catch(jsonToImmutableError);
}
